import React from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { TextField } from "../forms/textField";
import { Customer } from "../../models/responses/customer";

interface CustomerInfoModalProps {
  show: boolean;
  customer: Customer | undefined | null;
  onClose: () => void;
}

const CustomerInfoModal: React.FC<CustomerInfoModalProps> = ({
  show,
  customer,
  onClose,
}) => {
  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{customer?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <TextField label="Kund" value={customer?.name} colSize={6} />
            <TextField label="Kundnummer (AX)" value={customer?.externalId} colSize={6} />
          </Row>
          <Row>
            <TextField label="Adress" value={customer?.street} colSize={6} />
            <TextField label="E-post" value={customer?.email} colSize={6} />
          </Row>
          <Row>
            <TextField label="Telefon" value={customer?.phone} colSize={6} />
            <TextField label="Dokumentmapp" value={customer?.documentFolder} colSize={6} />
          </Row>
          <Row>
            <TextField label="Anteckning" value={customer?.comment} colSize={12} isTextarea />
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Stäng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomerInfoModal;
